export default {

  // 后台账号列表
  getAccountList(params, success) {
    Request.GET('/account', params, response => success(response));
  },

  // 查询账号详情
  getAccountDetail(id, success) {
    Request.GET(`/account/${id}`, null, response => success(response));
  },

  // 删除账号
  deleteAccount(id, success) {
    Request.DEL(`/account/${id}`, null, response => success(response));
  },

  // 启用、禁用
  setAccountStatus(id, success) {
    Request.POST(`/account/${id}/status`, null, response => success(response));
  },

  // 新增账号
  addAccount(params, success) {
    Request.POST('/account', params, response => success(response));
  },

  // 自己修改账号
  editAccountMyself(params, success) {
    Request.PUT('/account', params, response => success(response));
  },

  // 修改账号
  editAccount(id, params, success) {
    Request.PUT(`/account/${id}`, params, response => success(response));
  },

  accountBindWeiChat(params, success) {
    Request.POST('/account/bind/wx', params, response => success(response));
  },

  accountBindWeiChatById(params, success) {
    Request.POST(`/account/bind/wx/${params}`, null, response => success(response));
  },

  // 返回已绑定了微信的权限内用户列表
  getWeiChatNoticeUsers(params, success) {
    Request.GET('/account/wx/list', params, response => success(response));
  },

  /** 当前用户的菜单 */
  getCurrentMenuTree(success) {
    Request.GET('/account/menus', null, response => success(response));
  },

  /** 当前用户的权限 */
  getCurrentAccountPermission(success) {
    Request.GET('/account/permission', null, response => success(response));
  },
};



// WEBPACK FOOTER //
// ./src/api/accountApi.js